<!-- Apple-style 404 Page -->
<div class="apple-404-wrapper apple-fade-in">
  <div class="apple-container">
    <div class="apple-404-content">
      <!-- 404 Icon -->
      <div class="error-icon-wrapper apple-slide-up">
        <mat-icon class="error-icon">search_off</mat-icon>
      </div>

      <!-- Error Message -->
      <div class="error-message apple-slide-up">
        <h1 class="apple-heading-1 error-code">404</h1>
        <h2 class="apple-heading-2">Seite nicht gefunden</h2>
        <p class="apple-body-secondary">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
      </div>

      <!-- Navigation Options -->
      <div class="apple-404-actions apple-slide-up">
        <button class="apple-button apple-button-primary apple-button-large" routerLink="/">
          <mat-icon>home</mat-icon>
          Zur Startseite
        </button>
        <button class="apple-button apple-button-secondary apple-button-large" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
          Zurück
        </button>
      </div>

      <!-- Helpful Links -->
      <div class="apple-card helpful-links apple-slide-up">
        <h3 class="apple-heading-4">Hilfreiche Links</h3>
        <nav class="links-grid">
          <a routerLink="/orders" class="link-item">
            <mat-icon class="link-icon">shopping_cart</mat-icon>
            <span class="apple-body-small">Bestellungen</span>
          </a>
          <a routerLink="/faq" class="link-item">
            <mat-icon class="link-icon">help_outline</mat-icon>
            <span class="apple-body-small">FAQ</span>
          </a>
          <a routerLink="/feedback" class="link-item">
            <mat-icon class="link-icon">rate_review</mat-icon>
            <span class="apple-body-small">Feedback</span>
          </a>
          <a routerLink="/impressum" class="link-item">
            <mat-icon class="link-icon">info</mat-icon>
            <span class="apple-body-small">Impressum</span>
          </a>
        </nav>
      </div>
    </div>
  </div>
</div>
